<template>
  <div class="clearfix">
    <div class="t clearfix">
      <div class="border" v-bind:style="{'min-height' : winHeight + 'px'}">
        <div class="top"></div>
        <div class="center-date">
          <h1>{{yiji.Day}}</h1>
          <h4>{{yiji.year}}/{{yiji.month}}</h4>
          <p>{{yiji.week}}</p>
          <p>{{yiji.n_year}}年 {{yiji.n_month}} {{yiji.n_day}}</p>
        </div>
        <div class="bottom-content">
          <div class="content-list border-one">
            <h3 class="list-title clearfix">
              <span class="list-icon-yi"></span>
              <span>{{yiTitle}}</span>
            </h3>
            <p>{{yiDesc}}</p>
          </div>
        </div>
        <div class="bottom-content">
          <div class="content-list" >
            <h3 class="list-title-two clearfix">
              <span class="list-icon-two"></span>
              <span>{{jiTitle}}</span>
            </h3>
            <p>{{jiDesc}}</p>
          </div>
        </div>
      </div>
      <!-- <loading v-if="fullscreenLoading"></loading> -->
    </div>
    <div class="logo" v-on:click="logoB = !logoB" @touchmove.prevent>
        <img src="../assets/logo.png" alt="">
      </div>
      <div class="logoBg" v-if="logoB" v-on:click="logoB = false" @touchmove.prevent>
        <div class="logoTxt">
          <div class="logo-title clearfix">
            <img src="../assets/title-logo.png" alt="">
            <span>简介</span>
          </div>
          <p> 致力于倡导新中式健康生活，与你一同，感受身心节律，体验四时之美，换一种更自然的活法儿。</br></br>
            2007年成立至今，已有超过3000万用户使用了活法儿提供的“中医体质测试”、 “节气体质调理”等免费服务。旗下共有”过日子“等6款APP，全面覆盖饮食调养、月经调理、调体备孕、小病小痛等生活健康领域。</p>
        </div>
      </div>
  </div>
</template>

<script>
import Vue from 'vue'
import loading from './loading'

// import { MessageBox } from 'element-ui'
export default {
  data () {
    return {
      yiTitle: '',
      yiDesc: '',
      jiTitle: '',
      jiDesc: '',
      yiji: {},
      fullscreenLoading: true,     // londing
      winHeight: 667,
      logoB: false,
      yijiconent: ''
    }
  },
  components: {
    loading,
  },
  methods: {
    yijiData () {
      this.winHeight = window.screen.height - 100
      let tizhi = this.$route.query.tizhi
      let gender = this.$route.query.gender
      let yjData = this.url + 'day/yiji?gender=' + gender + '&tizhi=' + tizhi
      this.$http.get(yjData).then((response) => {
        this.yiji = response.data.data
        // this.yiji =
        // console.log(JSON.parse(response.data).data)
        Vue.prototype.yijiconent = this.yiji.n_month + this.yiji.n_day + '   宜：' + this.yiji.yi.title + '   忌：' + this.yiji.ji.title
        this.yiTitle = this.yiji.yi.title
        this.jiTitle = this.yiji.ji.title
        this.yiDesc = this.yiji.yi.desc
        this.jiDesc = this.yiji.ji.desc
        this.fullscreenLoading = false
      }).catch(function (response) {
        console.log(response)
      })
    }
  },
  mounted () {
    this.yijiData()
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
body{
  background: #f7f7f7;
}
.border{
  width: 3.48rem;
  min-height: 5rem;
  margin:.16rem auto .172rem;
  background: #fff;
  border: 1px solid #ccc;
  border-top: 0;
}
.top{
  width: 100%;
  height: .35rem;
  background: url(../assets/topIcon.png) no-repeat;
  background-size: 100%;

}
.center-date{
  padding-top: .15rem;
  padding-bottom: .05rem;
}
.center-date > h1{
  font-size: .6rem;
  font-weight: 400;
  line-height: .6rem;
  color: #333;
}
.center-date > h4{
  font-size: .18rem;
  line-height: .18rem;
  color: #888;
}
.center-date > p{
  font-size: .14rem;
  line-height: .14rem;
  color: #333;
  margin-top: .1rem;
}
.content-list{
  padding: .2rem .16rem;
}
.list-title{
  text-align: left;
  font-size: .16rem;
  color: #299939;
  font-weight: 600;
}
.list-title-two{
  text-align: left;
  font-size: .16rem;
  color: #888;
  font-weight: 600;
}
.list-title > span{
  float: left;
}
.list-icon-yi{
  display: inline-block;
  margin-right: .05rem;
  width: .22rem;
  height: .22rem;
  background: url(../assets/icon-yi.png) no-repeat;
  background-size: contain;
}
.content-list > p{
  font-size: .14rem;
  line-height: .23rem;
  color: #555;
  margin-top: .15rem;
  text-align: left;
}
.border-one{
  border-bottom: 1px solid #f7f7f7;
}
.list-title-two > span{
  float: left;
}
.list-icon-two{
  display: inline-block;
  margin-right: .05rem;
  width: .22rem;
  height: .22rem;
  background: url(../assets/icon-ji.png) no-repeat;
  background-size: contain;
}
/*logo*/
.logo{
  width: 100%;
  text-align: center;
}
.logo img{
  width: 1.2rem;
  margin: .2rem;
}
.logoBg {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
}
.logoTxt {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -1.75rem;
  margin-left: -1.625rem;
  border: 1px solid #fff;
  background: #fff;
  width: 3.25rem;
  padding: .3rem .2rem;
  border-radius: 10px;
  font-size: .14rem;
  text-align: center;
}
.logo-title{
  display: inline-block;
  margin: 0 auto;
}
.logo-title > img{
  float: left;
  width: .9rem;
}
.logo-title > span{
  float: left;
  margin-top: .02rem;
  margin-left: .03rem;
  font-size: .2rem;
  font-weight: 200;
}
.logoTxt > p {
  margin-top: .1rem;
  font-size: .16rem;
  color: #333;
  line-height: .24rem;
  text-align: left;
  font-weight: 300;
}
</style>



// WEBPACK FOOTER //
// Hello.vue?5bbc984c